import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';

const ProtectedRoute = ({ component: Component, ...rest }) => {
    const cookies = new Cookies();
    const referenceId = cookies.get('access_token');

    return (
        <Route {...rest} render={
            props => {
                if (referenceId) {
                    return <Component {...rest} {...props} />
                } else {
                    return <Redirect to={
                        {
                            pathname: '/',
                            state: {
                                from: props.location
                            }
                        }
                    } />
                }
            }
        } />
    )
}

export default ProtectedRoute;


// WEBPACK FOOTER //
// ./src/components/pages/common/ProtectedRoute.js